import { normalizeCountryCode, resolveMessageLanguage, type SupportedLanguage } from '@shared/core/localized-defaults'
import type { CountryOption } from 'src/modules/core/utils/country.utils'

export const COUNTRY_ANCHOR_ID = 'country'

type LanguageSwitchInput = {
  messageLanguage: SupportedLanguage | null | undefined
  savedCountry: string | null | undefined
  stagedCountry: string
}

/** `null` for a code the list does not offer (empty, or a territory the phone library lacks, such as AQ). */
export function findCountryOption(
  options: CountryOption[],
  countryCode: string | null | undefined,
): CountryOption | null {
  const code = normalizeCountryCode(countryCode)
  return options.find((option) => option.value === code) ?? null
}

/** The automatic language the staged country moves an Automatic account to, or `null` when it stays. */
export function resolveLanguageSwitch(input: LanguageSwitchInput): SupportedLanguage | null {
  if (input.messageLanguage != null) return null
  const before = resolveMessageLanguage({ messageLanguage: null, defaultCountryCode: input.savedCountry }).language
  const after = resolveMessageLanguage({ messageLanguage: null, defaultCountryCode: input.stagedCountry }).language
  return before === after ? null : after
}
